import { render } from "./NotificationRibbon.vue?vue&type=template&id=0912aa05"
import script from "./NotificationRibbon.vue?vue&type=script&lang=js"
export * from "./NotificationRibbon.vue?vue&type=script&lang=js"

import "./NotificationRibbon.vue?vue&type=style&index=0&id=0912aa05&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/NotificationRibbon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0912aa05"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0912aa05', __exports__)) {
    api.reload('0912aa05', __exports__)
  }
  
  module.hot.accept("./NotificationRibbon.vue?vue&type=template&id=0912aa05", () => {
    api.rerender('0912aa05', render)
  })

}


export default __exports__